import EventBus from './EventBus';

const mainEventBus = new EventBus();
window._mainEventBus = mainEventBus;

export default mainEventBus;
